// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Per assets/handoffs/design_handoff_sidebar_alerts, corrected by that
   handoff's FIXES.md: the region is pinned below the nav (outside its
   scroll container) and must shrink-wrap its content — no cap, no
   overflow, in any state including empty. The nav (flex:1 1 auto;
   min-height:0; overflow:auto — see SidebarMenu.js/admin.scss's
   .sidebar-menu flex-column setup, and AppShell/Sidebar.module.scss's
   .nav for the new shell) is the only band that scrolls. A 45%-capped,
   independently-scrolling region was the original spec line; it produced
   a second nested scrollbar next to the nav's and left an empty gap above
   the footer with only one alert — withdrawn. */

.sba-region {
  flex: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;
  border-top: 1px solid var(--border-secondary);
}

/* No shadow, no left-border accent stripe, no hover state on the card
   itself — the tint is the only emphasis. */
.sba-alert {
  position: relative;
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  grid-column-gap: 8px;
  column-gap: 8px;
  padding: 12px;
  border: 1px solid;
  border-radius: var(--radius-lg);
}

.sba-icon {
  width: 16px;
  height: 16px;
  margin-top: 2px;
}

.sba-body {
  min-width: 0;
}

.sba-body b {
  display: block;
  font-size: var(--text-sm-size);
  line-height: 20px;
  font-weight: 600;
}

.sba-body p {
  margin: 2px 0 0;
  font-size: var(--text-sm-size);
  line-height: 20px;
  font-weight: 400;
  text-wrap: pretty;
  /* Safety net, not a licence for long copy — the authored limit is still
     a title plus one sentence. Bounds the length at the content instead
     of clipping the fixed-height box the old spec used. */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

/* Room for the × so the title/body text can't run under it. */
.sba-pad-dismiss {
  padding-right: 20px;
}

/* On its own line, not inline in the sentence — that's the #1 "what
   changed" in the spec: inline it lands mid-line after a wrap and reads as
   emphasis, not a control. Inherits the alert's colour (not brand-700) in
   every variant but info — a magenta link inside a red field would read as
   a second, unrelated message. */
.sba-action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  font-size: var(--text-sm-size);
  line-height: 20px;
  font-weight: 600;
  color: inherit;
  text-decoration: none;
}

.sba-action--button {
  font-family: inherit;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
}

.sba-action:hover {
  text-decoration: underline;
  color: inherit;
}

.sba-dismiss {
  position: absolute;
  top: 8px;
  right: 8px;
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-xs);
  background: transparent;
  color: inherit;
  opacity: 0.55;
  cursor: pointer;
}

.sba-dismiss:hover {
  opacity: 1;
  background: rgba(10, 13, 18, 0.06);
}

.sba-dismiss:focus-visible {
  outline: 2px solid var(--color-brand-600);
  outline-offset: 1px;
  opacity: 1;
}

.sba-alert--critical {
  background: var(--color-error-25);
  border-color: var(--color-error-200);
  color: var(--color-error-700);
}

.sba-alert--critical .sba-icon {
  color: var(--color-error-600);
}

.sba-alert--warning {
  background: var(--color-warning-25);
  border-color: var(--color-warning-200);
  color: var(--color-warning-700);
}

.sba-alert--warning .sba-icon {
  color: var(--color-warning-600);
}

.sba-alert--promo {
  background: var(--color-brand-25);
  border-color: var(--color-brand-200);
  color: var(--color-brand-800);
}

.sba-alert--promo .sba-icon {
  color: var(--fg-brand-primary);
}

.sba-alert--info {
  background: var(--bg-secondary);
  border-color: var(--border-secondary);
  color: var(--text-tertiary);
}

.sba-alert--info b {
  color: var(--text-primary);
}

.sba-alert--info .sba-icon {
  color: var(--fg-quaternary);
}

.sba-alert--info .sba-action {
  color: var(--color-brand-700);
}
`, "",{"version":3,"sources":["webpack://./src/apps/admin/templates/PageTemplate/SidebarNotifications/SidebarAlerts.css"],"names":[],"mappings":"AAAA;;;;;;;;;gDASgD;;AAEhD;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,6CAA6C;AAC/C;;AAEA;4CAC4C;AAC5C;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,oBAAe;EAAf,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB;;0DAEwD;EACxD,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;AACrB;;AAEA;;;;iCAIiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["/* Per assets/handoffs/design_handoff_sidebar_alerts, corrected by that\n   handoff's FIXES.md: the region is pinned below the nav (outside its\n   scroll container) and must shrink-wrap its content — no cap, no\n   overflow, in any state including empty. The nav (flex:1 1 auto;\n   min-height:0; overflow:auto — see SidebarMenu.js/admin.scss's\n   .sidebar-menu flex-column setup, and AppShell/Sidebar.module.scss's\n   .nav for the new shell) is the only band that scrolls. A 45%-capped,\n   independently-scrolling region was the original spec line; it produced\n   a second nested scrollbar next to the nav's and left an empty gap above\n   the footer with only one alert — withdrawn. */\n\n.sba-region {\n  flex: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px 0;\n  border-top: 1px solid var(--border-secondary);\n}\n\n/* No shadow, no left-border accent stripe, no hover state on the card\n   itself — the tint is the only emphasis. */\n.sba-alert {\n  position: relative;\n  display: grid;\n  grid-template-columns: 16px minmax(0, 1fr);\n  column-gap: 8px;\n  padding: 12px;\n  border: 1px solid;\n  border-radius: var(--radius-lg);\n}\n\n.sba-icon {\n  width: 16px;\n  height: 16px;\n  margin-top: 2px;\n}\n\n.sba-body {\n  min-width: 0;\n}\n\n.sba-body b {\n  display: block;\n  font-size: var(--text-sm-size);\n  line-height: 20px;\n  font-weight: 600;\n}\n\n.sba-body p {\n  margin: 2px 0 0;\n  font-size: var(--text-sm-size);\n  line-height: 20px;\n  font-weight: 400;\n  text-wrap: pretty;\n  /* Safety net, not a licence for long copy — the authored limit is still\n     a title plus one sentence. Bounds the length at the content instead\n     of clipping the fixed-height box the old spec used. */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n}\n\n/* Room for the × so the title/body text can't run under it. */\n.sba-pad-dismiss {\n  padding-right: 20px;\n}\n\n/* On its own line, not inline in the sentence — that's the #1 \"what\n   changed\" in the spec: inline it lands mid-line after a wrap and reads as\n   emphasis, not a control. Inherits the alert's colour (not brand-700) in\n   every variant but info — a magenta link inside a red field would read as\n   a second, unrelated message. */\n.sba-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 8px;\n  font-size: var(--text-sm-size);\n  line-height: 20px;\n  font-weight: 600;\n  color: inherit;\n  text-decoration: none;\n}\n\n.sba-action--button {\n  font-family: inherit;\n  background: none;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n}\n\n.sba-action:hover {\n  text-decoration: underline;\n  color: inherit;\n}\n\n.sba-dismiss {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: grid;\n  place-items: center;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: 0;\n  border-radius: var(--radius-xs);\n  background: transparent;\n  color: inherit;\n  opacity: 0.55;\n  cursor: pointer;\n}\n\n.sba-dismiss:hover {\n  opacity: 1;\n  background: rgba(10, 13, 18, 0.06);\n}\n\n.sba-dismiss:focus-visible {\n  outline: 2px solid var(--color-brand-600);\n  outline-offset: 1px;\n  opacity: 1;\n}\n\n.sba-alert--critical {\n  background: var(--color-error-25);\n  border-color: var(--color-error-200);\n  color: var(--color-error-700);\n}\n\n.sba-alert--critical .sba-icon {\n  color: var(--color-error-600);\n}\n\n.sba-alert--warning {\n  background: var(--color-warning-25);\n  border-color: var(--color-warning-200);\n  color: var(--color-warning-700);\n}\n\n.sba-alert--warning .sba-icon {\n  color: var(--color-warning-600);\n}\n\n.sba-alert--promo {\n  background: var(--color-brand-25);\n  border-color: var(--color-brand-200);\n  color: var(--color-brand-800);\n}\n\n.sba-alert--promo .sba-icon {\n  color: var(--fg-brand-primary);\n}\n\n.sba-alert--info {\n  background: var(--bg-secondary);\n  border-color: var(--border-secondary);\n  color: var(--text-tertiary);\n}\n\n.sba-alert--info b {\n  color: var(--text-primary);\n}\n\n.sba-alert--info .sba-icon {\n  color: var(--fg-quaternary);\n}\n\n.sba-alert--info .sba-action {\n  color: var(--color-brand-700);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
